module.exports = __webpack_public_path__ + "img/default-box.80151ab7.png";